import type { RouteLocation } from 'vue-router';

/**
 * Very broadly used composable to get the current product based on the route.
 * Returns the product for the current offer flow, based on the productId in the route.
 *
 * In middlewares, we should not use useRoute(), therefore we can optionally pass a route as parameter.
 */
export function useProduct<T extends Product>(routeParam?: RouteLocation) {
    const productStore = useProductStore();
    // Get route
    const route = routeParam ?? useRoute();
    // Get productId from route
    const productId = computed<ProductId | undefined>(() => getProductIdFromRoute(route));
    // Get route based on productId.
    // ERROR if product not available!
    const product = computed<T>(() => {
        const result = productId.value ? productStore.products.find(p => p.id === productId.value) as T : undefined;
        if (!result) {
            throw new Error(`Product not found for current route: ${productId.value}`);
        }
        return result;
    });

    return {
        product,
    };
}
